import React from "react";
import PropTypes from "prop-types";

const GraphUp = ({ lineColor, graphColor, style, ...rest }) => {
  return (
    <svg
      style={{ maxWidth: "100%", height: "auto", display: "block", ...style }}
      viewBox="0 0 96 85"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...rest}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-321.000000, -63.000000)" fillRule="nonzero">
          <g transform="translate(256.000000, 6.000000)">
            <g transform="translate(65.500000, 57.931500)">
              <path
                d="M82.64285,54.4983 C82.64285,74.5713 82.34585,74.5713 82.34585,94.6428 C82.34585,95.3748 81.62735,96.2433 80.38235,96.2433 C71.44085,96.2433 71.44085,96.0528 62.49785,96.0528 C61.25285,96.0528 59.68985,95.3748 59.68985,94.6428 C59.68985,74.5713 60.91685,74.5713 60.91685,54.4983 C60.91685,53.7693 61.25285,53.4843 62.49785,53.4843 C71.44085,53.4843 71.44085,52.8063 80.38235,52.8063 C81.62735,52.8063 82.64285,53.7693 82.64285,54.4983"
                fill={graphColor}
              ></path>
              <polygon
                fill={graphColor}
                points="53.87405 65.2392 53.57255 80.0412 54.33905 94.8387 51.73055 95.8092 33.84455 96.3102 32.04005 94.8387 32.17955 80.0547 31.31405 65.2392 33.84455 64.3017 51.73055 64.5582"
              ></polygon>
              <polygon
                fill={lineColor}
                points="94.6334 0.39945 89.6249 22.42545 86.0669 32.65395 78.0764 28.21695 60.1319 44.57145 55.9814 49.15845 55.9904 49.74645 55.8104 50.77845 54.4469 50.70195 51.4844 53.88645 49.4009 54.83595 44.2904 52.02195 32.1254 44.30895 27.7169 40.54245 24.8114 44.24145 8.0234 58.24695 6.2399 58.24545 5.5739 58.76445 5.1899 57.97095 0.3449 55.32345 0.4094 52.90245 5.8349 47.25345 23.5349 30.07095 25.1159 30.14895 27.1244 29.36445 48.4979 42.44295 68.1269 21.88845 58.4159 15.60195"
              ></polygon>
              <polygon
                fill={graphColor}
                points="27.1685 72.61185 26.48 83.94585 27.5705 95.29035 23.984 94.75935 6.311 95.42085 3.095 95.30385 3.992 83.94735 4.811 72.76035 6.29 72.80235 24.0905 72.73935"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

GraphUp.propTypes = {
  lineColor: PropTypes.string.isRequired,
  graphColor: PropTypes.string.isRequired,
};

export default GraphUp;
